import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipPosition, MatTooltip } from '@angular/material/tooltip';

import { CypressTagDirective } from '@cjm/cypress/core';

import { IconType } from './fa-icon.const';

@Component({
	selector: 'fa-icon',
	template: `@if (alt) {
			<span class="cdk-visually-hidden">{{ alt }}</span>
		}
		<i
			matTooltipClass="c-mat-tooltip"
			cypressTag="General.FaIcon"
			[matTooltipPosition]="toolTipPosition"
			[class]="iconType + ' ' + icon + ' ' + classes"
			[matTooltipDisabled]="!toolTip"
			[matTooltip]="toolTip"
			[attr.aria-hidden]="true"
		></i>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatTooltip, CypressTagDirective]
})
export class FaIconComponent {
	@Input() icon: string;
	@Input() toolTip: string;
	@Input() iconType: `${IconType}` = IconType.solid;
	@Input() toolTipPosition: TooltipPosition = 'above';
	@Input() alt: string;
	@Input() classes: string = '';
}
